<template>
    <div class="progress">
        <div class="banner"></div>
        <div class="profile">
            <div class="profile-header">
                <div class="title">
                    <div class="cont_tit">
                        <p>活动专区</p>
                        <span>Event Zone</span>
                    </div>
                    <div class="crumb">
                        <span>当前位置：</span>
                        <a href="../" target="_self" title="首页" class="CurrChnlCls">首页</a>&gt;<a href="" target="_self"
                            title="活动专区" class="CurrChnlCls">活动专区</a>
                    </div>
                </div>
            </div>
            <div class="profile-conter">
                <ul class="conter-ul" v-if="dataList.length > 0">
                    <li class="conter-li" v-for="(item, index) in dataList" :key="index">
                      <a
                          :href="
                            '/zoneDetails?id=' +
                            item.reRecruitProjectId +
                            '&title=' +
                            item.title
                          "
                          target="_blank"
                        >
                            <img class="image" :src="item.src" alt="" />
                            <div class="activity-info">
                              <h3 class="activity-title">{{ item.title }}</h3>
                              <div class="activity-meta">
                                <span class="activity-job-count">共{{ item.num }}个岗位</span>
                                <span class="status-tag" :class="item.endStatus == '0'?'status-tag--ongoing':item.endStatus == '1'?'status-tag--end':''">{{ item.endStatus =="0"?'进行中':item.endStatus =="1"?"已结束":'' }}</span>
                              </div>
                            </div>
                        </a>
                    </li>
                </ul>
                <div class="box-body" v-else>
                    <div class="body-d">
                        <img src="../assets/images/zwsj.png" alt=""></img>
                        <div class="text"> 敬请期待 ~ </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getReRecruitProjectList, getPreviewUrl } from "@/api/index";
export default {
  name: "events",
  data() {
    return {
      dataList: [],
    };
  },
  created() {
    this.ReRecruitProjectList();
  },
  methods: {
    //招聘项目列表
    async ReRecruitProjectList() {
      await getReRecruitProjectList().then((res) => {
        if (res.code == 200) {
          res.data.forEach(async (item, i) => {
            if (item.visible == 1) {
              this.dataList.push({
                reRecruitProjectId: item.reRecruitProjectId,
                src: "",
                title: item.projectName,
                num: item.count,
                endStatus: item.endStatus,
              });
              await this.PreviewUrl(item, i);
            }
          });
        }
      });
    },

    async PreviewUrl(item, i) {
      await getPreviewUrl(item.webProjectPic).then((response) => {
        this.dataList[i].src = response.msg;
      }); 
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/cyzcpc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}

.profile {
  width: @main-width;
  margin: auto;

  &-header {
    padding-top: 50px;
    margin-bottom: 50px;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }

    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }

  &-conter {
    .conter-ul {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      margin-top: 5%;

      .conter-li {
        background-color: #fff;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
        box-sizing: content-box;
        margin-bottom: 20px;
        margin-right: 2%;
        width: 49%;
        border-radius: 10px;

        .image {
          width: 100%;
          height: 250px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }

        /* 活动信息栏样式 */
        .activity-info {
          padding: 12px 16px;
          .activity-title {
            font-size: 18px;
            color: #1f2924;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 8px;
          }
          .activity-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            color: #999;
            .activity-job-count {
              margin-right: 8px;
            }
            /* 状态标签基础样式 */
            .status-tag {
              padding: 2px 15px;
              border-radius: 12px;
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
            }

            /* 进行中标签优化样式 */
            .status-tag--ongoing {
              background-color: #e6f0ff;
              color: #409eff;
              border: 1px solid #c6e2ff;
              animation: pulse 2s infinite;
            }

            .status-tag--end{
              background-color: #e5e7eb;
              color: #999;
              border: 1px solid #d5d7dc;
              animation: pulse 2s infinite;
            }
          }
        }
      }

      .conter-li:nth-child(2n) {
        margin-right: 0;
      }
    }

    .box-body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      .body-d {
        width: 200px;
        height: 300px;

        img {
          width: 100%;
        }

        .text {
          text-align: center;
          color: #a3a3a3;
        }
      }
    }
  }
}
</style>